export class NICEAgent
{
    agentId: number;
    userName: string;
    firstName: string;
    middleName: string;
    name?: string;
    lastName: string;
    userId: string;
    emailAddress: string;
    isActive: boolean;
    teamId: number;
    teamName: string;
    reportToId: number;
    reportToName: string;
    isSupervisor: boolean;
    lastLogin: string;
    lastUpdated: string;
    location: string;
    custom1: string;
    custom2: string;
    custom3: string;
    custom4: string;
    custom5: string;
    internalId: string;
    profileId: number;
    profileName: string;
    timeZone: string;
    country: string;
    countryName: string;
    state: string;
    city: string;
    chatRefusalTimeout: number;
    phoneRefusalTimeout: number;
    workItemRefusalTimeout: number;
    defaultDialingPattern: string;
    defaultDialingPatternName: string;
    useTeamMaxConcurrentChats: number;
    maxConcurrentChats: number;
    notes: string;
    createDate: string;
    inactiveDate: string;
    hireDate: string;
    terminationDate: string;
    hourlyCost: number;
    rehireStatus: boolean;
    employmentType: number;
    employmentTypeName: string;
    referral: string;
    atHome: boolean;
    hiringSource: string;
    ntLoginName: string;
    scheduleNotification: number;
    federatedId: string;
    useTeamEmailAutoParkingLimit: boolean;
    maxEmailAutoParkingLimit: number;
    sipUser: string;
    systemUser: string;
    systemDomain: string;
    crmUserName: string;
    useAgentTimeZone: boolean;
    timeDisplayFormat: string;
    sendEmailNotifications: boolean;
    apiKey: string;
    telephone1: string;
    telephone2: string;
    userType: string;
    isWhatIfAgent: boolean;
    timeZoneOffset: string;
    requestContact: boolean;
    chatThreshold: number;
    useTeamChatThreshold: boolean;
    emailThreshold: number;
    useTeamEmailThreshold: boolean;
    workItemThreshold: number;
    useTeamWorkItemThreshold: boolean;
    contactAutoFocus: boolean;
    useTeamContactAutoFocus: boolean;
    useTeamRequestContact: boolean;
    voiceThreshold: number;
    useTeamVoiceThreshold:boolean;
    recordingNumbers: any;
    subject: string;
    issuer: string;
    isOpenIdProfileComplete: boolean;
    teamUuid: string;
    maxPreview: boolean;
    deliveryMode: string;
    totalContactCount: number;
    useTeamDeliveryModeSettings: number;
    emailRefusalTimeout: number;
    voicemailRefusalTimeout: number;
    smsRefusalTimeout: number;
    totalContactsHandled = 0;
    totalContactsOffered = 0;

    isBillable: boolean;
    agentVoiceThreshold: number;
    agentChatThreshold: number;
    agentEmailThreshold: number;
    agentWorkItemThreshold: number;
    agentDeliveryMode: string;
    agentTotalContactCount: number;
    agentContactAutoFocus: boolean;
    agentRequestContact: boolean;
    agentMaxVersion: number;
    customerCard: boolean;
    locked: boolean;
    userNameDomain: string;
    combinedUserNameDomain: string;
    rowNumber: number;
    SmsThreshold: number;
    UseTeamsmsThreshold: boolean;
    LoginAuthenticatorId: any;
    DigitalThreshold: number;
    UseTeamDigitalThreshold: false;
    AgentPhoneTimeout: any;
    AgentPhoneTimeoutSeconds: any;
    address1: string;
    address2: string;
    zipCode: string;
    noFixedAddress: boolean;
    DigitalRefusalTimeout: any;
    agentCxaClientVersion: any;
    agentCxaReleasePrevious: any;
    stateCode: string;
    AgentIntegration: boolean;

    constructor(jsonData?)
    {
        if (jsonData && jsonData.agentId){
            this.agentId = jsonData.agentId;
            this.userName = jsonData.userName;
            this.firstName = jsonData.firstName;
            this.middleName = jsonData.middleName;
            this.lastName = jsonData.lastName;
            this.userId = jsonData.userId;
            this.emailAddress = jsonData.emailAddress;
            this.isActive = jsonData.isActive;
            this.teamId = jsonData.teamId;
            this.teamName = jsonData.teamName;
            this.reportToId = jsonData.reportToId;
            this.reportToName = jsonData.reportToName;
            this.isSupervisor = jsonData.isSupervisor;
            this.lastLogin = jsonData.lastLogin;
            this.lastUpdated = jsonData.lastUpdated;
            this.location = jsonData.location;
            this.custom1 = jsonData.custom1;
            this.custom2 = jsonData.custom2;
            this.custom3 = jsonData.custom3;
            this.custom4 = jsonData.custom4;
            this.custom5 = jsonData.custom5;
            this.internalId = jsonData.internalId;
            this.profileId = jsonData.profileId;
            this.profileName = jsonData.profileName;
            this.timeZone = jsonData.timeZone;
            this.country = jsonData.country;
            this.countryName = jsonData.countryName;
            this.state = jsonData.state;
            this.city = jsonData.city;
            this.chatRefusalTimeout = jsonData.chatRefusalTimeout;
            this.phoneRefusalTimeout = jsonData.phoneRefusalTimeout;
            this.workItemRefusalTimeout = jsonData.workItemRefusalTimeout;
            this.defaultDialingPattern = jsonData.defaultDialingPattern;
            this.defaultDialingPatternName = jsonData.defaultDialingPatternName;
            this.useTeamMaxConcurrentChats = jsonData.useTeamMaxConcurrentChats;
            this.maxConcurrentChats = jsonData.maxConcurrentChats;
            this.notes = jsonData.notes;
            this.createDate = jsonData.createDate;
            this.inactiveDate = jsonData.inactiveDate;
            this.hireDate = jsonData.hireDate;
            this.terminationDate = jsonData.terminationDate;
            this.hourlyCost = jsonData.hourlyCost;
            this.rehireStatus = jsonData.rehireStatus;
            this.employmentType = jsonData.employmentType||1;
            this.employmentTypeName = jsonData.employmentTypeName;
            this.referral = jsonData.referral;
            this.atHome = jsonData.atHome;
            this.hiringSource = jsonData.hiringSource;
            this.ntLoginName = jsonData.ntLoginName;
            this.scheduleNotification = jsonData.scheduleNotification;
            this.federatedId = jsonData.federatedId;
            this.useTeamEmailAutoParkingLimit = jsonData.useTeamEmailAutoParkingLimit;
            this.maxEmailAutoParkingLimit = jsonData.maxEmailAutoParkingLimit;
            this.sipUser = jsonData.sipUser;
            this.systemUser = jsonData.systemUser;
            this.systemDomain = jsonData.systemDomain;
            this.crmUserName = jsonData.crmUserName;
            this.useAgentTimeZone = jsonData.useAgentTimeZone;
            this.timeDisplayFormat = jsonData.timeDisplayFormat;
            this.sendEmailNotifications = jsonData.sendEmailNotifications;
            this.apiKey = jsonData.apiKey;
            this.telephone1 = jsonData.telephone1;
            this.telephone2 = jsonData.telephone2;
            this.userType = jsonData.userType;
            this.isWhatIfAgent = jsonData.isWhatIfAgent;
            this.timeZoneOffset = jsonData.timeZoneOffset;
            this.requestContact = jsonData.requestContact;
            this.chatThreshold = jsonData.chatThreshold;
            this.useTeamChatThreshold = jsonData.useTeamChatThreshold;
            this.emailThreshold = jsonData.emailThreshold;
            this.useTeamEmailThreshold = jsonData.useTeamEmailThreshold;
            this.workItemThreshold = jsonData.workItemThreshold;
            this.useTeamWorkItemThreshold = jsonData.useTeamWorkItemThreshold;
            this.contactAutoFocus = jsonData.contactAutoFocus;
            this.useTeamContactAutoFocus = jsonData.useTeamContactAutoFocus;
            this.useTeamRequestContact = jsonData.useTeamRequestContact;
            this.voiceThreshold = jsonData.voiceThreshold;
            this.recordingNumbers = jsonData.recordingNumbers;
            this.subject = jsonData.subject;
            this.issuer = jsonData.issuer;
            this.isOpenIdProfileComplete = jsonData.isOpenIdProfileComplete;
            this.teamUuid = jsonData.teamUuid;
            this.maxPreview = jsonData.maxPreview;
            this.deliveryMode = jsonData.deliveryMode;
            this.totalContactCount = jsonData.totalContactCount;
            this.useTeamDeliveryModeSettings = jsonData.useTeamDeliveryModeSettings;
            this.emailRefusalTimeout = jsonData.emailRefusalTimeout;
            this.voicemailRefusalTimeout = jsonData.voicemailRefusalTimeout;
            this.smsRefusalTimeout = jsonData.smsRefusalTimeout;
            this.name = (jsonData.firstName + ' ' + jsonData.middleName + ' ' + jsonData.lastName).replace('  ', ' ');
        }
    }
}
